import React from "react";
import PropTypes from "prop-types";
import classes from "./page-banner.scss";

// slim: a one-line banner, so the icons page starts near the top
const PageBanner = ({ title, subtitle, slim }) => (
  <section className={slim ? `${classes.section} ${classes.slim}` : classes.section}>
    <div className={classes.inner}>
      {title}
      {subtitle}
    </div>
  </section>
);

PageBanner.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  slim: PropTypes.bool,
};

export default PageBanner;
